<template>
  <div>
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form class="form-horizontal">
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button-raised p-button-rounded" @click.prevent="openPropertyDialog" style="float: right"
                  icon="pi pi-plus"/>
        </div>
      </div>
      <!-- <i class="pi pi-plus-circle"></i> -->
      <Dialog header="Property Setup" :visible.sync="propertySetup"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">

        <!-- <form class="form-horizontal"> -->
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-3">
            <label for="name" style="font-size:12px"> Name
              <span style="color:red">*</span>
            </label>
            <InputText id="name" v-model="propertyName"/>
          </div>

          <div class="p-field p-col-4 p-mt-5">
            <RadioButton name="UserDefine" value="UserDefine"
                         v-model="propertyTypeName"/>
            <label>UserDefine</label>
            <RadioButton name="Default" value="Default"
                         v-model="propertyTypeName"/>
            <label>Default</label>
          </div>
          <div class="p-field p-col-2" v-if="propertyTypeName !== 'UserDefine'">
            <label for="city1">Details</label>
            <Button class="p-button-secondary" label="Details"
                    @click.prevent="openDetailDialog"/>
          </div>
          <div class="p-field p-col-2">
            <Button class="p-button-raised p-mt-5" :label="editing?'Update':'Add'"
                    @click.prevent="addItemToDTOList"/>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <DataTable
              :value="itemPropertyList"
              :paginator="true"
              :rows="8"
              class="p-datatable-responsive p-datatable-gridlines"
            >
              <Column field="propertyName" header="Name">
              </Column>
              <Column field="propertyTypeName" header="Entry Type">
                <template #body="slotProps">
                  <RadioButton inputId="city1" name="UserDefine" value="UserDefine"
                               v-model="slotProps.data[slotProps.column.field]" disabled="true"/>
                  <label for="city1">UserDefine</label>
                  <RadioButton inputId="city2" name="Default" value="Default"
                               v-model="slotProps.data[slotProps.column.field]" disabled="true"/>
                  <label for="city2">Default</label>

                </template>
              </Column>

              <Column header="Details">
                <template #body="sl">
                  <!--                  {{sl.data.childIItemMasterPropertyList}}-->
                  <Button class="p-button-secondary" v-if="sl.data['propertyTypeName'] !== 'UserDefine'" label="Details"
                          @click.prevent="addOpenDetailsDialog(sl.data.childIItemMasterPropertyList)"/>
                </template>
              </Column>
            </DataTable>
          </div>

        </div>
        <template #footer>
          <Button class="p-button-raised p-button-rounded" :label="editing?'Update':'Add'" @click.prevent="saveItemPropertySetup"/>
          <!--                    <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New"/>-->
          <Button class="p-button-raised p-button-success" label="Back" @click.prevent="cancel"/>
        </template>
      </Dialog>
      <Dialog header="Detail Setup" :visible.sync="detailSetup"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-4">
            <label for="parentProperty"> Parent Property</label>
            <InputText v-model="parentName" id="parentProperty"/>
          </div>
          <div class="p-field p-col-1">
            <Button class="p-button-raised p-mt-5" label="Add" @click.prevent="addChildItemProperty"/>
          </div>

          <DataTable
            :value="childIItemMasterPropertyList"
            :paginator="true"
            :rows="8"
            class="p-datatable-gridlines">
            <Column header="Property Name" field="propertyName">
            </Column>
            <Column>
              <template #body="sl">
                <Button class=" p-button-text p-button-danger" label="Remove"
                        @click.prevent="removeParentProperty(sl.index)"/>
              </template>
            </Column>
          </DataTable>

        </div>
        <template #footer>
          <Button class="p-button-raised p-button-rounded" label="Save" @click.prevent="saveChildItemProperty"/>
          <Button class="p-button-raised p-button-danger" label="Cancel"
                  @click.prevent="cancelDetailDialog"/>
        </template>
      </Dialog>
      <Dialog header="Detail Setup" :visible.sync="addDialog"
              :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'auto'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-4">
            <label> Parent Property</label>
            <InputText v-model="parentName"/>
          </div>
          <div class="p-field p-col-1">
            <Button class="p-button-raised p-mt-5" label="Add" @click.prevent="addChildItemProperty"/>
          </div>

          <DataTable
            :value="childItemData"
            :paginator="true"
            :rows="8"
            class="p-datatable-gridlines">
            <Column header="Property Name" field="propertyName">
            </Column>
            <Column>
              <template #body="sl">
                <Button class=" p-button-text p-button-danger" label="Remove"
                        @click.prevent="removeParentProperty(sl.index)"/>
              </template>
            </Column>
          </DataTable>

        </div>
        <template #footer>
          <Button class="p-button-raised p-button-rounded" label="Save" @click.prevent="saveChildItemProperty"/>
          <Button class="p-button-raised p-button-danger" label="Back"
                  @click.prevent="cancelDetailDialog"/>
        </template>
      </Dialog>
    </form>
  </div>
</template>
<script>
import RadioButton from 'primevue/radiobutton'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default {
  name: 'propertySetup',
  data() {
    return {
      editing: false,
      commissionName: '',
      loading: false,
      id: null,
      propertySetup: false,
      noOfProperty: 0,
      propertyTypeName: 'UserDefine',
      propertyName: '',
      itemPropertyList: [],
      childIItemMasterPropertyList: [],
      childItemData: [],
      detailSetup: false,
      parentName: '',
      addDialog: false
    }
  },
  methods: {
    addItemToDTOList() {
      let item = {
        propertyName: this.propertyName,
        propertyTypeName: this.propertyTypeName,
        childIItemMasterPropertyList: this.childIItemMasterPropertyList || this.childItemData
      }
      this.itemPropertyList.push({...item})
      this.resetDto()
    },
    // saveItemPropertySetup() {
    //   let itemProperty = {
    //     itemPropertyList: this.itemPropertyList
    //   }
    //   console.log(itemProperty)
    //   // debugger
    // },
    async saveItemPropertySetup() {
      let response = ''
      // if (this.propertyName === '') {
      //   this.$toast.add({severity: 'error', summary: '', detail: 'Name cannot be empty!', life: 10000})
      //   return
      // }
      let itemProperty = {
        itemPropertyList: this.itemPropertyList,
        id: this.id
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createItemProperty', itemProperty)
        // this.$emit('set_data', response.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateItemProperty', itemProperty)
        this.loading = false
      }
      this.reponseCheck(response)
    },
    cancel() {
      this.editing = false
      this.itemPropertyList = []
      this.childItemData = []
      this.propertySetup = false
    },
    openPropertyDialog() {
      this.propertySetup = true
    },
    addOpenDetailsDialog(data) {
      this.childItemData = data
      this.addDialog = true
    },
    openDetailDialog() {
      this.detailSetup = true
    },
    cancelDetailDialog() {
      this.addDialog = false
      this.detailSetup = false
    },
    resetDto() {
      this.propertyName = ''
      this.propertyTypeName = 'UserDefine'
      this.childIItemMasterPropertyList = []
    },
    addChildItemProperty() {
      let childProperty = {
        propertyName: this.parentName
      }
      if (this.addDialog === true) {
        this.childItemData.push(childProperty)
      } else {
        this.childIItemMasterPropertyList.push(childProperty)
      }
      this.resetParentProperty()
    },
    removeParentProperty(ind) {
      if (this.addDialog === true) {
        this.childItemData.splice(ind, 1)
      } else {
        this.childIItemMasterPropertyList.splice(ind, 1)
      }
    },
    saveChildItemProperty() {
      this.addDialog = false
      this.detailSetup = false
    },
    resetParentProperty() {
      this.parentName = ''
    },
    openItemPropertySetup(data) {
      this.editing = true
      this.propertyName = data.propertyName
      this.id = data.id
      this.openPropertyDialog()
    },
    reponseCheck(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.closePropertyItemDialog()
      }
    },
    closePropertyItemDialog() {
      this.resetDto()
      this.propertySetup = !this.propertySetup
    }
    // closePropertyDialog() {
    //   this.propertySetup = !this.propertySetup
    // }
  },
  components: {
    Dialog,
    RadioButton,
    Button,
    InputText,
    InputNumber,
    DataTable,
    Column
    // Toast
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// propertySetup.vue?407d7576